import actions from './actions'
import mutations from './mutations'
import { getDictOfAttributes } from '@/appLogic/targets/targetDefinition'
import { ACTIVATION_STATUS, DESTINATIONS } from '@/appLogic/targets/Constants'
import { isActivationBlocked, isTargetOwnedBy } from '@/helpers'

/**
 * How to add modules after a store has been created...
 * note that dirty is not wired up yet, watch TargetDefinition does the work
 */

const DEFAULT_STATE = {
  interface: null,
  attributes: null,
  slottedValue: null,
  enableSaving: null,
  enableDownstream: true,
  // the workbench Target contians the following
  // changing the name with displayname
  // changing the advertiser
  workbenchTarget: null,
  targetCreateAction: null,
  enableDefinitionActions: true,
  loadingWorkbench: false,
  dirty: false,
  showAUPModal: false,
  showModelingModal: 0,
  availableDestinations: [],
  selectedFamilyDataset: null, // this is the dataset family that is selected, each dataset is associated with a family of datasets that are compatible with them
  availableAttributes: null, // this contains all the Attributes, so that we can set attributes soly as the attributes shown
  selectedDatasets: null, // when null no family dataset is set or selected
  datasetFamilies: null, // the structure used to identify the families used for each set of datasets from the attributes that are chosen from the user
}

const state = function () {
  return {
    ...DEFAULT_STATE,
  }
}

// TODO will need to move the store of the LAS so that any workbench can be used as intended
const getters = {
  selectedFamilyDataset(state) {
    return state.selectedFamilyDataset
  },
  availableDestinations(state) {
    return state.availableDestinations
  },
  workbenchAttributes(state) {
    return state.attributes
  },
  // TODO this will have to change latter on
  newTargetDefinition(state, getters) {
    return state.interface ? state.interface.getTargetDefinition(getters) : getters.serializedDefinition
  },
  targetCreateAction(state) {
    return state.targetCreateAction
  },
  newDictOfTargetAttributes(state, getters) {
    let td = getters.newTargetDefinition
    return td ? getDictOfAttributes(td, el => el.value) : null
  },
  newWorkbenchTarget(state) {
    return state.workbenchTarget
  },
  saveXandrSegmentEnabled(state) {
    return state.enableSaving
  },
  enableDefinitionActions(state) {
    return state.enableDefinitionActions
  },
  workbenchTargetIsLive(state) {
    return (state.workbenchTarget || {}).activation_status === ACTIVATION_STATUS.LIVE
  },
  showAUPModal(state) {
    return false
  },
  showModelingModal(state) {
    return state.showModelingModal
  },
  newWorkbenchTargetIsDigital(state) {
    let t = state.workbenchTarget
    return t.destinations.includes(DESTINATIONS.KRUX) || t.destinations.includes(DESTINATIONS.LIVERAMP)
  },
  datasetFilter(state) {
    if (state.selectedDatasets) {
      return state.selectedDatasets
    } else {
      return []
    }
  },
  showGenerateEstimate: (state, getters, rootState, rootGetters) => {
    let target = state.workbenchTarget
    if (target && target.display_name) {
      let activationBlocked = isActivationBlocked(target.target)
      let cantShow = target.activated || !isTargetOwnedBy(target, rootGetters.username) || activationBlocked
      return !cantShow
    } else {
      return false
    }
  },
}

// TODO need to add in the modules for the target definition
const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default module

export { DEFAULT_STATE as WORKBENCH_DEFAULT_STATE }



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/common/store/index.js